import BookingService from '../../../Services/BookingService';
import { announceTripClaimsRefused, tripClaimsRefusalOf } from '../../../Utils/tripClaims';

/**
 * THE write that completes a booking. Every "Mark Completed" in the dashboard
 * — the Orders row menu, the past-trip warning button, the offer the Trip
 * claims page makes once a booking's last claim is dealt with — goes through
 * this one call, so there is one completion path and not two.
 *
 * It is POST /bookings, which the API answers with `createOrModifyBooking`:
 * the same `assertCanComplete` guard the nightly job's `partialUpdateBooking`
 * passes through (both end in it via BookingsService), and the same
 * `executePostUpdateActions` afterwards — the SNS publish that triggers the
 * post-trip email, the agent notification and the driver push. A raw status
 * write would skip all of that.
 *
 * It does not catch: the caller decides what a 409 (trip claims still waiting)
 * looks like on its screen.
 *
 * @param {object} order the booking, as the API returned it
 */
export const completeBooking = (order) => BookingService.postBooking({
  ...order,
  status: 'Completed',
  send_notification_to_customer: false,
});

/**
   * Mark the order as completed
   * @param {object} order
   */
export default (
  {
    setIsLoading, fetchOrders, setError,
  },
) => async (order) => {
  setIsLoading(true);
  try {
    await completeBooking(order);
    setIsLoading(false);
    fetchOrders();
  } catch (err) {
    // Trip claims still waiting for review: the API refuses (409) with the
    // counts; TripClaimsRefusalAlert shows it with the way to review them.
    const refusal = tripClaimsRefusalOf(err);
    if (refusal) announceTripClaimsRefused(order, refusal);
    else setError?.(err.response?.data?.message || err.message);
  } finally {
    setIsLoading(false);
  }
};
